module.exports = __webpack_public_path__ + "img/MES10Indice2_cutout.ab57c420.png";